<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <comparables-leases-grid [hidden]="!showGrid" [workspace]="this"></comparables-leases-grid>
    <comparables-leases-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                   [workspace]="this"
                   [showPrevBtn]="previousButtonEnabled"
                   [showNextBtn]="nextButtonEnabled"
                   (showPrevious)="showPrevious()"
                   (showNext)="showNext()">
    </comparables-leases-form>
  </div>
</div>
